import { h } from 'vue';
import { LOCK_TYPE_MAP } from '@/components/lock-bar/constants';
import type { LockTypeMode } from '@/components/lock-bar/constants';
import { RouteLocationRaw } from 'vue-router';
import { useRouterStore } from '@/store';
import { Notification, Space, Button } from '@arco-design/web-vue';

export const handleMessageByLock = (
  item: Recordable,
  msg: string[],
  title = '提示',
  openMsgMode: 'push' | 'newWindow' = 'push'
) => {
  const { id, scope, data = {} } = item;
  const { type } = LOCK_TYPE_MAP[scope as LockTypeMode];
  if (!id || !type) return;
  const [prefix = '', suffix = ''] = msg;
  let message = suffix;
  let routerName = '';
  const routerQuery: Recordable = {};
  switch (type) {
    case 1: {
      // 商品
      const { goodsSn, name } = data;
      message = `${prefix}商品${name}(${goodsSn})${message}`;
      routerName = 'EditGoods';
      routerQuery.id = id;
      break;
    }
    case 2: {
      // 设计款
      const { designSn, name } = data;
      message = `${prefix}设计款${name}(${designSn})${message}`;
      routerName = 'EditDesignPro';
      routerQuery.id = id;
      break;
    }
    case 3: {
      // 版单
      const { designOrderSn } = data;
      message = `${prefix}版单${designOrderSn}${message}`;
      routerName = 'EditDesignOrder';
      routerQuery.id = id;
      break;
    }
    default:
  }
  if (!routerName) return;
  const handleNotification = () => {
    const notificationId = `${Date.now()}`;
    const closeNotification = Notification.info({
      id: notificationId,
      title,
      content: message,
      duration: 0,
      footer: () => {
        // 底部的内容，2.25.0版本以上才有的，使用的是RenderFunction
        return h(Space, [
          h(
            Button,
            {
              type: 'secondary',
              size: 'small',
              onClick: () => closeNotification.close(),
            },
            '关闭'
          ),
          h(
            Button,
            {
              type: 'primary',
              size: 'small',
              onClick: () => handleConfirm(),
            },
            '查看'
          ),
        ]);
      },
    });
    const handleConfirm = () => {
      const routerObj: any = {
        name: routerName,
        query: {},
        params: {},
      };
      Object.assign(routerObj.query, routerQuery);
      openMessage(routerObj, openMsgMode);
      closeNotification.close();
    };
  };

  handleNotification();

  // Modal.confirm({
  //   title: '确认解除锁定通知',
  //   okText: '查看',
  //   cancelText: '关闭',
  //   content: message,
  //   onOk: () => {
  //     const routerObj: any = {
  //       name: routerName,
  //       query: {},
  //       params: {},
  //     };
  //     Object.assign(routerObj.query, routerQuery);
  //     openNewWindow(routerObj);
  //   },
  // });
};

// 处理解锁通知跳转
export const handleUnlockMessage = (item: Recordable) => {
  handleMessageByLock(
    item,
    ['', '已经解除编辑锁定，您可以前往编辑资料了'],
    '确认解除锁定通知'
  );
};

// 处理接口action = UPDATE_FAIL_ON_LOCK_EFFECT(5) 全量更新(商品/设计款/版单)失败的message处理
export const handleUpdateFailMessage = (item: string) => {
  const messageItem = JSON.parse(item)?.[0];
  if (!messageItem) return;
  handleMessageByLock(
    messageItem,
    ['', '部分数据处于编辑锁定，无法全量更新，请先解除锁定'],
    '提示',
    'newWindow'
  );
};

const openMessage = (data: RouteLocationRaw, openMode = 'push') => {
  try {
    const { globalRouter } = useRouterStore();
    if (openMode === 'push') {
      globalRouter.push(data);
      return;
    }
    const addHref = globalRouter.resolve(data);
    window.open(addHref.href, '_blank');
  } catch {
    //
  }
};

// const openNewWindow = (data: RouteLocationRaw) => {
//   try {
//     const { globalRouter } = useRouterStore();
//     const addHref = globalRouter.resolve(data);
//     window.open(addHref.href, '_blank');
//   } catch {
//     //
//   }
// };

export default handleUnlockMessage;
